import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { startCase } from 'lodash';
import { LevelText } from '@dyl/systems/LevelsManager';
import DataGridDyl from '@dyl/components/DataGridDyl';
import quickDateFormat from '@dyl/utils/quickDateFormat';

/**
 * @typedef Props
 * @property {string} taskIds
 * @property {(taskIds: string[]) => void} onConfirmChanges
 * @property {import('./logic').TaskOption[]} taskOptions
 */

/** @type {import('@mui/x-data-grid').GridColDef[]} */
const Columns = [
    { headerName: 'Task ID', field: 'task_id_name', flex: 3 },
    { headerName: 'Level', field: 'level_id', flex: 2, renderCell({ value }) {
        return <LevelText levelId={value} />;
    }
    },
    { headerName: 'Skill', field: 'skill_id', flex: 2, valueFormatter({ value }) {
        return startCase(value);
    }
    },
    { headerName: 'Last modified', field: 'updated_at', flex: 2, valueFormatter({ value }) {
            return value ? quickDateFormat(value) : 'Unavailable';
    }
    },
];

const getRowId = task => task.task_id;

/**
 * @param {Props & import('@mui/material').DialogProps} props
 */
export default function TaskPicker(props) {
    const {
        taskIds,
        onConfirmChanges: propsOnConfirm,
        open,
        onClose,
        taskOptions,
        ...other
    } = props;

    const [internalList, setInternalList] = useState([]);

    useEffect(() => {
        if (open) {
            setInternalList([...taskIds]);
        }
    }, [open]);

    const onConfirm = () => {
        propsOnConfirm([...internalList]);
        onClose();
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth='lg'
            {...other}
        >
            <DialogTitle>
                Choose tasks to add to the component
            </DialogTitle>

            <DialogContent>
                <DataGridDyl
                    columns={Columns}
                    rows={taskOptions}
                    selectionModel={internalList}
                    onSelectionModelChange={s => setInternalList(s)}
                    selectionType='ordered-checkboxes'
                    getRowId={getRowId}
                    localeText={lang}
                    searchField='task_id_name'
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>
                    Cancel
                </Button>

                <Button
                    data-testid='file-picker-add-item'
                    color='primary'
                    onClick={onConfirm}
                    variant='contained'
                    id='AddTaskToComponentButton'
                >
                    Add to Component
                </Button>
            </DialogActions>
        </Dialog>
    );
}

/** @type {import('@mui/x-data-grid').GridLocaleText} */
const lang = {
    footerRowSelected: count => `${count} tasks selected`,
};